import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as globalReducer from "containers/App/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as oldProjectReducer from "containers/OldProject/reducer";
import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as modelGroupReducer from "containers/ModelGroup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import { getSelectedAccount } from "containers/Accounts/reducer";
import { getIsModelSplits } from "containers/ModelGroup/reducer";
import { getIsMarketplace } from "containers/Marketplace/reducer";
import { getAibleMode } from "containers/Wizard/reducer";

import injectReducer from "utils/injectReducer";

import Header from "components/OldProject/Header";

class HeaderContainer extends React.PureComponent {
  render() {
    const {
      runId,
      datasetId,
      dataset,
      currentState,
      modelPlotData,
      cloudURL,
      isQuickRun,
      models,
      updateStep,
      success,
      runCost,
      step
    } = this.props;

    const isSetup = !runId || runId === "new";

    return <Header isSetup={isSetup} {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStep: (step) => dispatch(oldProjectReducer.updateStep(step)),
  updateLabel: (label) => dispatch(oldProjectReducer.updateModelName(ownProps.runId, label)),

  handleCancel: () => dispatch(runReducer.cancelRun(ownProps.runId)),
  initJob: () => dispatch(setupReducer.initModifiedRun(ownProps.runId, ownProps.blueprintId, true)),

  updateRelatedId: (relatedId, skipSetup) =>
    dispatch(runReducer.updateRelatedId(ownProps.originalId, relatedId, skipSetup)),

  createSetupFromSpecial: (specialVals) =>
    dispatch(setupReducer.createSetupFromSpecial(ownProps.originalId, specialVals)),

  updateSpecialIndex: (specialIndex) => dispatch(runReducer.updateSpecialIndex(ownProps.originalId, specialIndex)),

  createModelGroup: () => dispatch(modelGroupReducer.createModelGroup(ownProps.originalId)),
  deleteModelGroup: (modelGroupId) => dispatch(modelGroupReducer.deleteModelGroup(ownProps.originalId, modelGroupId)),
  deleteSubModelGroup: (subModelGroupId) =>
    dispatch(modelGroupReducer.deleteSubModelGroup(ownProps.originalId, subModelGroupId)),
  linkModelToGroup: (specialVals) => dispatch(modelGroupReducer.linkModelToGroup(ownProps.originalId, specialVals)),
  updatePriority: (specialId, priortyDelta) =>
    dispatch(modelGroupReducer.updatePriority(ownProps.originalId, specialId, priortyDelta)),

  updateDeployedModel: (subGroupIndex, model) =>
    dispatch(modelGroupReducer.updateDeployedModel(ownProps.originalId, subGroupIndex, model)),

  updateIsEditing: (isEditing) => dispatch(blueprintReducer.updateIsEditing(ownProps.blueprintId, isEditing)),

  updateBlueprint: () => dispatch(blueprintReducer.saveCurrentBlueprint(ownProps.blueprintId)),
  createNewBlueprint: () => dispatch(blueprintReducer.createBlueprint(ownProps.runId, ownProps.blueprintId)),
  reloadBlueprint: () => dispatch(blueprintReducer.reloadBlueprint(ownProps.blueprintId)),
  lockBlueprint: (isLocked) => dispatch(blueprintReducer.lockBlueprint(ownProps.blueprintId, isLocked)),

  updatePanelMode: (panelMode) =>
    dispatch(runReducer.updatePanelMode(ownProps.originalId, ownProps.blueprintId, panelMode)),

  updateMode: (mode) => dispatch(runReducer.updateMode(ownProps.originalId, mode)),

  deployModelGroup: () => dispatch(deploymentsReducer.deployModelGroup(ownProps.originalId)),

  createRunFromDataset: (datasetId) => dispatch(projectReducer.createRunFromDataset(ownProps.projectId, datasetId)),

  setRunId: (runId) => dispatch(projectReducer.setRunId(ownProps.projectId, runId))
});

const mapStateToProps = (state, ownProps) => {
  const runId = ownProps.runId;
  const datasetId = runReducer.getJob(state, runId).datasetId;

  const status = runReducer.getStatus(state, runId);

  const selectedAccount = getSelectedAccount(state);

  return {
    runId: runId,
    datasetId: datasetId,
    dataset: homeReducer.getDataset(state, datasetId),
    datasets: homeReducer.getDatasetsArr(state),

    altFrontiers: projectReducer.getAlternateFrontiers(state, ownProps.projectId),

    blueprint: blueprintReducer.getBlueprint(state, ownProps.blueprintId),

    specialOptions: homeReducer.getSpecialOptions(state, datasetId),

    isRunning: status !== undefined && status !== "DONE" && status !== "ERROR",

    status: status,

    serverProgress: runReducer.getServerProgress(state, runId),
    notebookProgress: runReducer.getNotebookProgress(state, runId),

    isContinuous: runReducer.getIsContinuous(state, runId),
    success: setupReducer.getSuccess(state, runId),
    successPct: setupReducer.getSuccessPct(state, runId),

    isQuickRun: setupReducer.getIsQuickRun(state, runId),

    label: setupReducer.getLabel(state, runId),
    isAzure: selectedAccount && selectedAccount.type === "AZURE",

    setupChanged: setupReducer.getSetupChanged(state, runId),

    specialIndex: runReducer.getSpecialIndex(state, ownProps.originalId),
    panelMode: runReducer.getPanelMode(state, ownProps.originalId),

    models: runReducer.getTransformedSortedModels(state, ownProps.runId),

    modelGroup: modelGroupReducer.getModelGroup(state, ownProps.originalId),
    linkedModels: modelGroupReducer.getLinkedModels(state, ownProps.originalId),

    isModelSplits: getIsModelSplits(),
    isModelGroupsLoading: globalReducer.getIsModelGroupsLoading(state),

    mode: runReducer.getMode(state, ownProps.originalId),

    isMarketplace: getIsMarketplace(),

    isEditing: blueprintReducer.getIsEditing(state, ownProps.blueprintId, ownProps.runId),
    isBlueprintLocked: blueprintReducer.getIsLocked(state, ownProps.blueprintId),
    canLockBlueprint: blueprintReducer.getCanLockBlueprint(state, ownProps.blueprintId),
    isAibleBlueprint: blueprintReducer.getIsAibleBlueprint(state, ownProps.blueprintId),
    modelGroupDeploy: deploymentsReducer.getModelGroupDeploy(state, ownProps.originalId),

    isCreateNewBlueprint: blueprintReducer.getIsCreateNewBlueprint(state, ownProps.runId, ownProps.blueprintId),

    steps: blueprintReducer.getSteps(state, ownProps.originalId, ownProps.blueprintId),
    aibleMode: getAibleMode(state, ownProps.originalId, ownProps.blueprintId),

    isDataMode: globalReducer.getIsDataMode(state),
    selectedFolder: foldersReducer.getSelectedFolderData(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(HeaderContainer);
